// extracted by mini-css-extract-plugin
export default {"image":"scF1wj"};